var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitterCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Circle_Black",
    "data-name": "Circle Black",
    transform: "translate(0 0.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Twitter",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M14.5,29A14.5,14.5,0,0,1,8.856,1.14,14.5,14.5,0,0,1,20.144,27.861,14.408,14.408,0,0,1,14.5,29ZM6.37,19.6h0a9.388,9.388,0,0,0,5.091,1.5h.027a9.621,9.621,0,0,0,4.073-.862,8.951,8.951,0,0,0,2.971-2.226,9.77,9.77,0,0,0,1.82-3.052,9.651,9.651,0,0,0,.618-3.338v-.433A6.728,6.728,0,0,0,22.62,9.465a6.742,6.742,0,0,1-1.914.525,3.327,3.327,0,0,0,1.47-1.845,6.633,6.633,0,0,1-2.116.808A3.333,3.333,0,0,0,14.3,11.232a3.415,3.415,0,0,0,.086.761A9.491,9.491,0,0,1,7.506,8.53,3.332,3.332,0,0,0,8.53,12.965a3.353,3.353,0,0,1-1.512-.415v.044a3.332,3.332,0,0,0,2.675,3.265,3.392,3.392,0,0,1-1.5.058A3.327,3.327,0,0,0,11.3,18.229a6.687,6.687,0,0,1-4.119,1.419H7.164A6.769,6.769,0,0,1,6.37,19.6Z",
    transform: "translate(0 -0.343)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterCircle);
export default __webpack_public_path__ + "static/media/twitter-circle.05237cdbedc296fbda05c3d4f9d8265c.svg";
export { ForwardRef as ReactComponent };